import React from "react";

const InternationalContext = React.createContext({});

export const InternationalProvider = InternationalContext.Provider;
export const InternationalConsumer = InternationalContext.Consumer;
export default InternationalContext;
